import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { useTypedSelector } from "./useTypedSelector";
import { useChangePasswordMutation } from "../store/query/auth";

const useChangePassword = () => {
  const [changePassword, { isLoading }] = useChangePasswordMutation();
  const { user } = useTypedSelector((store) => store.appUser);

  const handleSubmit = async (values) => {
    try {
      const res = await changePassword(values);
      //console.log("change-password", res, values);

      if (res?.data?.status) {
        toast.success(res.data.message || "Password changed successfully");
      } else {
        toast.error(res?.error?.data?.message || "Something went wrong");
      }
    } catch (error) {
      toast.error("An error occurred while changing password");
    }
  };

  const formik = useFormik({
    initialValues: {
      old_password: "",
      new_password: "",
      confirm_password: "",
    },
    validateOnMount: true,
    validationSchema: Yup.object({
      old_password: Yup.string().required("Current password is required"),
      new_password: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/,
          "Password must include one lowercase, one uppercase, and a number"
        )
        .required("New password is required"),
      confirm_password: Yup.string()
        .oneOf([Yup.ref("new_password"), null], "Passwords must match")
        .required("Confirm password is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      const payload = {
        type: user?.account_type,
        old_password: values.old_password,
        new_password: values.new_password,
        _method: "PATCH",
      };
      await handleSubmit(payload);
      resetForm();
    },
  });

  return {
    ...formik,
    isLoading,
    onSubmit: (values, noroute) => handleSubmit(values, noroute),
  };
};

export default useChangePassword;
